<template>
    <!-- <v-img src="@/assets/Images/slRAOS.jpg" width="100%" height="90vh"></v-img> -->

    <v-sheet class="pa-6" width="100%" height="90vh" color="transparent">
        <l-map
        class="mapClassBorder"
        :zoom="zoomMap" 
        :center="centerMap"
        :options="{ zoomControl: false}">
            <l-control-zoom :position="'topright'"  ></l-control-zoom>
            <l-tile-layer :url="finalURL"></l-tile-layer>
            <l-control position="topleft" >
                <v-sheet color="transparent" width="100" height="100">
                    <v-img src="@/assets/Images/hcgroup.jpg"></v-img>
                </v-sheet>
            </l-control>
            <l-control position="bottomleft" >
                <div class="mb-4"><span class="mapInnerTittle">SmartLink RAOS</span></div>
                
                <div><span  class="mapInnerSubTittle">Remote & Autonomous Operation System</span></div>
            </l-control>

            <l-marker v-for="(m, index) in finalItems" :key="index" :lat-lng="m.position??[0,0]" >
                
                <l-icon :iconSize='[40, 60]' :iconAnchor="[35,30]" >
                    <v-sheet color='transparent' :width="70" class="text-center">
                        <img :height="'70'" :src="CONSTANTIMGS.IMAGES.perforadora"/>
                        <v-sheet :class="'classnameIconRAOS'" color="bgTopology" >
                            <h5> {{m.name}} </h5>
                        </v-sheet>
                    </v-sheet>
                </l-icon>                
            </l-marker>
        </l-map>
    </v-sheet>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import axios from 'axios';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTMAPS from '@/constants/maps';
import CONSTANTIMGS from '@/constants/images';
import { APIS_KPI, APIS_MAP, APIS_DRIVE } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 ************ LEAFLET ***********
 *******************************/
import { LMap, LTileLayer, LMarker, LIcon, LControlZoom, LControl } from "@vue-leaflet/vue-leaflet";
import { PointExpression } from 'leaflet';
import "/public/leaflet/leaflet.css";

const zoomMap = computed( () => CONSTMAPS.zoom.value);
const centerMap = ref<PointExpression>([CONSTMAPS.latitud.value,CONSTMAPS.longitud.value])
const finalURL = ref('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}')


const finalPositions = ref<any>({})

async function getAllPosition() {
    await axios.get(APIS_DRIVE.value.getRajantGPS, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then(async (response) => {
        response.data.forEach((item:any) => {

            if(!finalPositions.value[item.ip]) {
                finalPositions.value[item.ip] = {}
            }

            finalPositions.value[item.ip].fecha = item.fecha;
            finalPositions.value[item.ip].position = [item.latitud, item.longitud];
        })
    })
}


const finalItems = ref<any>([])


async function  getAllLatencyLastMinute() {
    await axios.get(APIS_KPI.value.getAllLatency, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) => {
        const items = response.data;
        items.forEach((item:any) => {
            if(item.tipo.toUpperCase() === 'PERFORADORA'){
                const position = finalPositions.value[item.ip]?.position??null; 

              finalItems.value.push({
                name: item.name,
                ip: item.ip,
                position,
                tipo: item.tipo,
                status: 'ok'
              })
            }
        })
        console.log('finalItems', finalItems.value);
    })
}

onMounted(async() => {
    await getAllPosition()
    await getAllLatencyLastMinute()
})

</script>

<style>
.mapInnerTittle{
    font-size: 40px;
    font-weight: bold;
}
.mapInnerSubTittle{
    font-size: 20px;
}

.classnameIconRAOS{
    border-radius: 5px;
    width: 80px;
    overflow: hidden;
    border: 1px solid #000;
}
</style>